/*!
 *   Copyright 2022  SenX S.A.S.
 *
 *   Licensed under the Apache License, Version 2.0 (the "License");
 *   you may not use this file except in compliance with the License.
 *   You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 *   Unless required by applicable law or agreed to in writing, software
 *   distributed under the License is distributed on an "AS IS" BASIS,
 *   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *   See the License for the specific language governing permissions and
 *   limitations under the License.
 */
:host {
  display: block;
  width: 100%;
  height: 100%;
  position: relative;
}
:host .expander {
  position: absolute;
  top: 0;
  left: 0;
  width: 35px;
  z-index: 9;
  margin: 5px;
}
:host .chart-area {
  position: absolute;
  top: 20px;
  left: 0;
  width: 100%;
  z-index: 5;
}
:host .discovery-chart-spinner {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  z-index: 900;
}